<app-header></app-header>
<div class="page-margin">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
